// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__I68og","unreadBadge":"styles_unreadBadge__jQTKU","modalContent":"styles_modalContent__1uUEO","modal":"styles_modal__290w4"};